import { playSound, Sound } from '~/assets/sounds';
import { KeyButton } from '../KeyButton';
import {
	StyledButtonContainer,
	StyledContainer,
	StyledLabel,
} from './PanelControls.styled';

interface IPanelControl {
	text: string;
	keys: string[];
	visible?: boolean;
	onClick?: () => void;
}

interface IPanelControlsProps {
	controls: IPanelControl[];
	align?: 'left' | 'right';
	fullScreenLayout?: boolean;
}

const PanelControls = ({
	controls,
	align,
	fullScreenLayout = false,
	...props
}: IPanelControlsProps) => {
	return (
		<StyledContainer $align={align} {...props}>
			{controls.map((control, cIndex) => {
				const visible =
					typeof control.visible === 'undefined' ? true : control.visible;
				return visible ? (
					<StyledButtonContainer
						key={`controls#${cIndex}`}
						onClick={() => {
							if (typeof control.onClick !== 'undefined') {
								control.onClick?.();
								playSound(Sound.ClickButton);
							}
						}}
						$clickable={typeof control.onClick !== 'undefined'}
						onMouseEnter={() => {
							if (typeof control.onClick !== 'undefined') {
								playSound(Sound.LinkCursor);
							}
						}}
						$fullScreenLayout={fullScreenLayout}
					>
						{control.keys.map((keyName, kIndex) => (
							<KeyButton key={`key#${kIndex}`} keyName={keyName} />
						))}
						<StyledLabel>{control.text}</StyledLabel>
					</StyledButtonContainer>
				) : null;
			})}
		</StyledContainer>
	);
};

export { PanelControls };
